module.exports = __webpack_public_path__ + "static/img/chain-org-num.375b2967.png";